import React, { useEffect, useState, useRef, useContext } from "react";
import ModalGlobal from "../../../components/ModalGlobal/ModalGlobal";
import MedalInfoMobile from "./InfoActivitiesMedal/MedalInfo.Mobile";
import MedalInfoDesktop from "./InfoActivitiesMedal/MedalInfo.Desktop";
import InfoActivitiesHeader from "./InfoActivitiesHeader/InfoActivitiesHeader";
import InfoActivitiesContent from "./InfoActivitiesContent/InfoActivitiesContent";
import InfoActivitiesPDF from "./infoActivitiesPDF/infoActivitiesPDF";
import MedalInfoHeader from "./InfoActivitiesMedal/MedalInfoHeader";
import { useTheme, useMediaQuery } from "@mui/material";
import SystemContext from "../../../context/SystemContext";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";


const AModalInfoActivities = ({
  infoActivity,
  medal,
  setInfoActivity = () => { },
  openMedal,
  setOpenMedal = () => { },
  setOpenGame,
  getRecommendedActivity,
  setTaskActivity,
  handleFavorited,
  openFavoriteMessage,
  showMsg,
  hideFavoriteButton = false,
  infoActivityIsQuiz
}) => {
  
  const { changePropertyUrl } = useContext(SystemContext);
  const navigate = useNavigate();
  const [openStateModalGlobal, setOpenStateModalGlobal] = useState(null);
  const [modalConfigs, setModalConfigs] = useState(null);
  const modalRef = useRef();
  const [modalShow, setModalShow] = useState();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const InfoMedalComponent = isMobile ? MedalInfoMobile : MedalInfoDesktop;

  const [searchParams] = useSearchParams();
  const paramsActivity = searchParams.get("atividade");
  const paramsLanguage = searchParams.get("idioma");
  const tabParam = searchParams.get("tab");
  const { pathname } = useLocation();

  //? Atualizar as configurações do modal sempre que mudar a activity
  useEffect(() => {
    if (infoActivity) {
      const configs = generateModalConfigs();
      setModalConfigs(configs);
      if (paramsActivity !== infoActivity.path) {
        const newPropertyUrl = {}
        newPropertyUrl["atividade"] = infoActivity.path
        if (infoActivity.language !== "Português") {
          const langMap = {
            "Português Europeu": "pt_eu",
            "Inglês": "en_us",
            "Espanhol": "es_es"
          }
          newPropertyUrl["idioma"] = langMap[infoActivity.language] ?? infoActivity.language
        }
        const stayOnPage = pathname === "/fazer-teste/plano" ||
          (pathname === "/jogos" && (tabParam === "FavoriteActivities" || tabParam === "MyActivities"));
        if (stayOnPage) {
          changePropertyUrl("", newPropertyUrl)
        } else {
          changePropertyUrl("/jogos", newPropertyUrl)
        }
      }
    }
  }, [infoActivity, openMedal, medal, showMsg]);

  useEffect(() => {
    if (modalConfigs) {
      // console.log("modalConfigs changed:", modalConfigs);
      setOpenStateModalGlobal(true);
    }
  }, [modalConfigs]);

  //? Gerar as configurações do modal
  const generateModalConfigs = () => {
    const newModalConfig = [
      {
        title: "",
        modalStateOpen: true,
        size: isMobile || isTablet ? "Medium" : "ExtraLarge",
        customComponent: (
          <InfoActivitiesHeader
            activity={infoActivity}
            setOpenState={setOpenStateModalGlobal}
            onCloseModal={onCloseModal}
          />
        ),
        content: (
          <InfoActivitiesContent
            activity={infoActivity}
            modalRef={modalRef}
            medal={medal}
            openMedal={openMedal}
            setOpenMedal={setOpenMedal}
            infoActivity={infoActivity}
            setOpenGame={setOpenGame}
            setInfoActivity={setInfoActivity}
            getRecommendedActivity={getRecommendedActivity}
            setTaskActivity={setTaskActivity}
            setOpenState={setOpenStateModalGlobal}
            handleFavorited={handleFavorited}
            showMsg={showMsg}
            hideFavoriteButton={hideFavoriteButton}
            openFavoriteMessage={() => openFavoriteMessage(infoActivity)}
            isQuiz={infoActivityIsQuiz}
          />
        ),
        actions: [],
        scheme: ["customComponent", "content"],
      },
      {
        title: "",
        modalStateOpen: true,
        size: isMobile || isTablet ? "Medium" : "ExtraLarge",
        customComponent: (
          <MedalInfoHeader
            medal={medal}
            setOpenState={setOpenStateModalGlobal}
            modalRef={modalRef}
            openMedal={openMedal}
            setOpenMedal={setOpenMedal}
          />
        ),
        content: (
          <InfoMedalComponent
            modalRef={modalRef}
            show={modalShow}
            medal={medal}
            showStatus={setModalShow}
            setOpenGame={setOpenGame}
            activity={infoActivity}
          />
        ),
        actions: [{ type: "nextModal", text: "next" }],
        scheme: ["customComponent", "content"],
      },
      {
        title: "Leitor PDF",
        modalStateOpen: true,
        size: isMobile || isTablet ? "Medium" : "ExtraLarge",
        content: (
          <InfoActivitiesPDF modalRef={modalRef} infoActivity={infoActivity} />
        ),
        actions: [],
        scheme: ["content"],
      },
    ];

    return newModalConfig;
  };

  const onCloseModal = () => {
    if (tabParam) {
      navigate(`/jogos?tab=${tabParam}`);
    } else {
      changePropertyUrl("", {});
    }
  }

  useEffect(() => {
    if (!openStateModalGlobal) {
      setInfoActivity(null);
      setOpenMedal(null);
      setModalConfigs(null);
    }
  }, [openStateModalGlobal]);

  // Fecha o ModalGlobal quando infoActivity for setado para null
  useEffect(() => {
    if (!infoActivity) {
      setOpenStateModalGlobal(false); // fecha o modal global
      setModalConfigs(null); //remove todas as telas/configs do modal
    }
  }, [infoActivity]);

  return (
    <ModalGlobal
      ref={modalRef}
      startModal={0}
      openState={openStateModalGlobal}
      setOpenState={setOpenStateModalGlobal}
      modalConfigs={modalConfigs}
      onCloseModal={onCloseModal}
    />
  );
};
export default AModalInfoActivities;
